import { useState } from "react";
import { FalloutCharacter, FalloutCharacterStatus } from "../Data/Response";


interface MovementOrdersModalViewArgs {
    characterId: string;
    otherCharacters: FalloutCharacter[];
    submitGetMoving: (characterId: string, movementOrderCharacterIds: string[]) => void;
}

const MovementOrdersModalView: React.FC<MovementOrdersModalViewArgs> = args => {
    var [movementOrderCharacterIds, setMovementOrderCharacterIds] = useState<string[]>([]);

    return <div>
        <h1>Get Moving</h1>
        <h3>Give Movement Orders</h3>
        <p>You can give movement orders to other characters. They will each take 1 fatigue, but get to move independently.</p>
        <ul>
            {args.otherCharacters.map(c => {
                if (c.state.fatigue > 1 || c.state.status !== "active" || c.id === args.characterId) {
                    return null;
                }
                const id = `movementOrder${c.id}`;
                return <li>
                    <input
                        type="checkbox"
                        id={id}
                        checked={movementOrderCharacterIds.includes(c.id)}
                        onChange={e => {
                            setMovementOrderCharacterIds(prev => {
                                return e.target.checked ? [...prev, c.id] : prev.filter(id => id !== c.id);
                            })
                        }}
                    ></input>
                    <label htmlFor={id}>{c.name}</label>
                </li>
            })}
        </ul>
        <button
            onClick={e => {
                args.submitGetMoving(args.characterId, movementOrderCharacterIds);
            }}
        >Start Moving!</button>
    </div>
}

export default MovementOrdersModalView;